"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.developerApiPaymentListResponseSchema = exports.developerApiInvoiceListResponseSchema = exports.developerApiEstimateListResponseSchema = exports.developerApiJobListResponseSchema = exports.developerApiCustomerListResponseSchema = exports.developerApiPaymentSchema = exports.developerApiInvoiceSchema = exports.developerApiInvoiceSummarySchema = exports.developerApiEstimateSchema = exports.developerApiEstimateSummarySchema = exports.createDeveloperApiJobRequestSchema = exports.developerApiJobSchema = exports.developerApiJobSummarySchema = exports.createDeveloperApiCustomerRequestSchema = exports.developerApiCustomerSchema = exports.developerApiCustomerSummarySchema = exports.developerApiPaymentListQuerySchema = exports.developerApiInvoiceListQuerySchema = exports.developerApiEstimateListQuerySchema = exports.developerApiJobListQuerySchema = exports.developerApiCustomerListQuerySchema = exports.developerApiProblemSchema = exports.developerApiProblemIssueSchema = exports.developerApiCredentialSecretResponseSchema = exports.createDeveloperApiCredentialRequestSchema = exports.developerApiCredentialListResponseSchema = exports.developerApiCredentialSchema = exports.developerApiCredentialStatusSchema = exports.DEVELOPER_API_SCOPES = exports.developerApiScopeSchema = exports.DEVELOPER_API_REQUEST_ID_HEADER = exports.DEVELOPER_API_IDEMPOTENCY_HEADER = exports.DEVELOPER_API_KEY_HEADER = exports.DEVELOPER_API_CONTRACT_VERSION = void 0;
const zod_1 = require("zod");
const customer_1 = require("./customer");
const estimate_1 = require("./estimate");
const finance_1 = require("./finance");
const invoice_1 = require("./invoice");
const job_1 = require("./job");
const pagination_1 = require("./pagination");
exports.DEVELOPER_API_CONTRACT_VERSION = "crewfsm.developer-api.v1";
exports.DEVELOPER_API_KEY_HEADER = "authorization";
exports.DEVELOPER_API_IDEMPOTENCY_HEADER = "idempotency-key";
exports.DEVELOPER_API_REQUEST_ID_HEADER = "x-request-id";
exports.developerApiScopeSchema = zod_1.z.enum([
    "customers:read",
    "customers:write",
    "jobs:read",
    "jobs:write",
    "estimates:read",
    "invoices:read",
    "payments:read",
]);
exports.DEVELOPER_API_SCOPES = exports.developerApiScopeSchema.options;
exports.developerApiCredentialStatusSchema = zod_1.z.enum(["ACTIVE", "REVOKED"]);
exports.developerApiCredentialSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string().min(2).max(120),
    keyPrefix: zod_1.z.string().min(8).max(40),
    scopes: zod_1.z.array(exports.developerApiScopeSchema),
    tenantId: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    locationId: zod_1.z.string().uuid().nullable(),
    status: exports.developerApiCredentialStatusSchema,
    createdAt: zod_1.z.string().datetime(),
    rotatedAt: zod_1.z.string().datetime().nullable(),
    revokedAt: zod_1.z.string().datetime().nullable(),
    lastUsedAt: zod_1.z.string().datetime().nullable(),
});
exports.developerApiCredentialListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.developerApiCredentialSchema),
});
exports.createDeveloperApiCredentialRequestSchema = zod_1.z.object({
    name: zod_1.z.string().trim().min(2).max(120),
    scopes: zod_1.z
        .array(exports.developerApiScopeSchema)
        .min(1)
        .max(exports.DEVELOPER_API_SCOPES.length)
        .refine((scopes) => new Set(scopes).size === scopes.length, {
        message: "Scopes must be unique.",
    }),
    locationId: zod_1.z.string().uuid().nullable().optional().default(null),
});
exports.developerApiCredentialSecretResponseSchema = zod_1.z.object({
    credential: exports.developerApiCredentialSchema,
    apiKey: zod_1.z.string().min(40),
});
exports.developerApiProblemIssueSchema = zod_1.z.object({
    path: zod_1.z.string(),
    message: zod_1.z.string(),
});
exports.developerApiProblemSchema = zod_1.z.object({
    type: zod_1.z.string(),
    title: zod_1.z.string(),
    status: zod_1.z.number().int().min(400).max(599),
    detail: zod_1.z.string(),
    instance: zod_1.z.string(),
    code: zod_1.z.string().regex(/^[A-Z][A-Z0-9_]*$/),
    requestId: zod_1.z.string().min(1),
    issues: zod_1.z.array(exports.developerApiProblemIssueSchema).optional(),
});
const listQueryFields = {
    search: zod_1.z
        .string()
        .trim()
        .min(1)
        .max(160)
        .optional()
        .transform((value) => value || undefined),
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(50),
    cursor: zod_1.z.string().trim().min(1).max(4_096).optional(),
};
exports.developerApiCustomerListQuerySchema = zod_1.z.object(listQueryFields);
exports.developerApiJobListQuerySchema = zod_1.z.object({
    ...listQueryFields,
    status: job_1.jobStatusSchema.optional(),
    locationId: zod_1.z.string().uuid().optional(),
    customerId: zod_1.z.string().uuid().optional(),
});
exports.developerApiEstimateListQuerySchema = zod_1.z.object({
    ...listQueryFields,
    status: estimate_1.estimateStatusSchema.optional(),
    customerId: zod_1.z.string().uuid().optional(),
});
exports.developerApiInvoiceListQuerySchema = zod_1.z.object({
    ...listQueryFields,
    status: invoice_1.invoiceStatusSchema.optional(),
    financialStatus: invoice_1.invoiceFinancialStatusSchema.optional(),
    customerId: zod_1.z.string().uuid().optional(),
});
exports.developerApiPaymentListQuerySchema = zod_1.z
    .object({
    from: zod_1.z.string().datetime(),
    to: zod_1.z.string().datetime(),
    locationId: zod_1.z.string().uuid().optional(),
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(50),
    cursor: zod_1.z.string().trim().min(1).max(4_096).optional(),
})
    .refine((value) => Date.parse(value.to) > Date.parse(value.from), {
    path: ["to"],
    message: "The end of the range must be after the start.",
});
exports.developerApiCustomerSummarySchema = customer_1.customerSummarySchema.pick({
    id: true,
    type: true,
    displayName: true,
    email: true,
    phone: true,
    status: true,
    primaryLocation: true,
    locationCount: true,
    createdAt: true,
    updatedAt: true,
});
exports.developerApiCustomerSchema = customer_1.customerDetailSchema.pick({
    id: true,
    type: true,
    displayName: true,
    email: true,
    phone: true,
    status: true,
    contacts: true,
    locations: true,
    createdAt: true,
    updatedAt: true,
});
exports.createDeveloperApiCustomerRequestSchema = customer_1.createCustomerRequestSchema;
exports.developerApiJobSummarySchema = job_1.jobSummarySchema.pick({
    id: true,
    jobNumber: true,
    summary: true,
    description: true,
    priority: true,
    status: true,
    customer: true,
    serviceLocation: true,
    operationalLocation: true,
    subtotalCents: true,
    taxCents: true,
    totalCents: true,
    nextAppointment: true,
    createdAt: true,
    updatedAt: true,
});
exports.developerApiJobSchema = job_1.jobDetailSchema.pick({
    id: true,
    jobNumber: true,
    summary: true,
    description: true,
    priority: true,
    status: true,
    customer: true,
    serviceLocation: true,
    operationalLocation: true,
    subtotalCents: true,
    taxCents: true,
    totalCents: true,
    appointments: true,
    lines: true,
    createdAt: true,
    updatedAt: true,
});
exports.createDeveloperApiJobRequestSchema = job_1.createJobRequestSchema.omit({
    appointment: true,
});
exports.developerApiEstimateSummarySchema = estimate_1.estimateSummarySchema.pick({
    id: true,
    estimateNumber: true,
    status: true,
    customer: true,
    serviceLocation: true,
    currentVersionNumber: true,
    subtotalCents: true,
    taxCents: true,
    totalCents: true,
    expiresAt: true,
    sentAt: true,
    acceptedAt: true,
    declinedAt: true,
    createdAt: true,
    updatedAt: true,
});
exports.developerApiEstimateSchema = estimate_1.estimateDetailSchema.pick({
    id: true,
    estimateNumber: true,
    status: true,
    customer: true,
    serviceLocation: true,
    currentVersionNumber: true,
    subtotalCents: true,
    taxCents: true,
    totalCents: true,
    expiresAt: true,
    sentAt: true,
    acceptedAt: true,
    declinedAt: true,
    notes: true,
    lines: true,
    createdAt: true,
    updatedAt: true,
});
exports.developerApiInvoiceSummarySchema = invoice_1.invoiceSummarySchema.pick({
    id: true,
    invoiceNumber: true,
    status: true,
    financialStatus: true,
    job: true,
    customer: true,
    serviceLocation: true,
    currentVersionNumber: true,
    paymentTerms: true,
    dueAt: true,
    subtotalCents: true,
    taxCents: true,
    totalCents: true,
    amountPaidCents: true,
    balanceCents: true,
    issuedAt: true,
    voidedAt: true,
    createdAt: true,
    updatedAt: true,
});
exports.developerApiInvoiceSchema = invoice_1.invoiceDetailSchema.pick({
    id: true,
    invoiceNumber: true,
    status: true,
    financialStatus: true,
    job: true,
    customer: true,
    serviceLocation: true,
    currentVersionNumber: true,
    paymentTerms: true,
    dueAt: true,
    subtotalCents: true,
    taxCents: true,
    totalCents: true,
    amountPaidCents: true,
    balanceCents: true,
    issuedAt: true,
    voidedAt: true,
    notes: true,
    lines: true,
    createdAt: true,
    updatedAt: true,
});
exports.developerApiPaymentSchema = finance_1.financeTransactionSchema;
exports.developerApiCustomerListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.developerApiCustomerSummarySchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema.default(pagination_1.defaultPageInfo),
});
exports.developerApiJobListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.developerApiJobSummarySchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema.default(pagination_1.defaultPageInfo),
});
exports.developerApiEstimateListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.developerApiEstimateSummarySchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema.default(pagination_1.defaultPageInfo),
});
exports.developerApiInvoiceListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.developerApiInvoiceSummarySchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema.default(pagination_1.defaultPageInfo),
});
exports.developerApiPaymentListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.developerApiPaymentSchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema.default(pagination_1.defaultPageInfo),
});
//# sourceMappingURL=developer-api.js.map